import { render, staticRenderFns } from "./LandingFlow.vue?vue&type=template&id=70ea3d34&"
import script from "./LandingFlow.vue?vue&type=script&lang=js&"
export * from "./LandingFlow.vue?vue&type=script&lang=js&"
import style0 from "./LandingFlow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports